module.exports = __webpack_public_path__ + "static/media/fathom-final.eba3cc9d.png";